// extracted by mini-css-extract-plugin
export default {"productItem":"ProductItem_productItem__yuciD","thumb":"ProductItem_thumb__7My-I","contents":"ProductItem_contents__M1V6j","testInfo":"ProductItem_testInfo__WIDth"};